import type { ReactNode } from 'react';

import { Icon } from '../Icon';

import styles from './Tag.module.css';

export type TagType = 'default' | 'neutral' | 'success' | 'warning' | 'danger' | 'info';
/** 用于非功能语义的业务分类；状态、风险与结果仍应使用 type。 */
export type TagCategory = 'blue' | 'violet' | 'cyan';
export type TagTopic = 'plain' | 'light' | 'dark';
export type TagSize = 'large' | 'default' | 'small';

export interface TagProps {
  children: ReactNode;
  category?: TagCategory;
  className?: string;
  closable?: boolean;
  /** 关闭按钮的可访问名称；多个标签时应指明具体对象，如“移除语文券”。 */
  closeLabel?: string;
  onClose?: () => void;
  size?: TagSize;
  topic?: TagTopic;
  type?: TagType;
}

export function Tag({ children, category, className, closable = false, closeLabel = '移除标签', onClose, size = 'default', topic = 'light', type = 'default' }: TagProps) {
  return (
    <span className={[styles.root, className].filter(Boolean).join(' ')} data-category={category} data-closable={closable || undefined} data-size={size} data-topic={topic} data-type={type}>
      <span className={styles.label}>{children}</span>
      {closable ? <button aria-label={closeLabel} className={styles.close} data-icon="close" onClick={onClose} type="button"><Icon name="close" size="xs" /></button> : null}
    </span>
  );
}
